export const MODULE_NAME = 'checkAvailability';
